<template>
  <div class="productDetailBox">
    <div class="productDetail">
      <h1 class="title">{{ dataObj.title }}</h1>
      <div class="bigBox">
        <div class="blBox">
          <img class="img" :src="dataObj.img" alt="" />
        </div>
        <div class="brBox">
          <div class="brbBpx">
            <div class="brtBox">Model：{{ dataObj.chipset }}</div>
            <div class="brbLeft" v-if="$route.query.id == 403">
              <div class="text">
                <h5>Price</h5>
                <p>{{ dataObj.price }}</p>
              </div>
              <div class="text">
                <h5>Screen Size</h5>
                <p>{{ dataObj.size }}</p>
              </div>
              <div class="text">
                <h5>Memory Storage Capacity</h5>
                <p>{{ dataObj.capacity }}</p>
              </div>
              <div class="text">
                <h5>Battery Life</h5>
                <p>{{ dataObj.life }}</p>
              </div>
              <div class="text">
                <h5>Display Resolution</h5>
                <p>{{ dataObj.resolution }}</p>
              </div>
              <div class="text">
                <h5>Color</h5>
                <p>{{ dataObj.color }}</p>
              </div>
              <div class="text">
                <h5>Product Dimensions</h5>
                <p>{{ dataObj.dimensions }}</p>
              </div>
            </div>
             <div class="brbLeft" v-else>
              <div class="text">
                <h5>Frequency Range (MHz)</h5>
                <p>{{ dataObj.frequency }}</p>
              </div>

              <div class="text">
                <h5>3dB Horizontal Beam Width (° )</h5>
                <p>{{ dataObj.hor }}</p>
              </div>
              <div class="text">
                <h5>Gain (dBi)</h5>
                <p>{{ dataObj.gain }}</p>
              </div>
              <div class="text">
                <h5>Electrical Downtilt(° )</h5>
                <p>{{ dataObj.electrical }}</p>
              </div>
              <div class="text">
                <h5>Dimension(mm)</h5>
                <p>{{ dataObj.dimension }}</p>
              </div>
              <div class="text">
                <h5>Radome Material</h5>
                <p>{{ dataObj.radome }}</p>
              </div>
              <div class="text">
                <h5>Connector Type</h5>
                <p>{{ dataObj.connector }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="productDetailTwo">
      <h1 class="title">{{ dataObj.title }}</h1>
      <div class="blBox">
        <img class="img" :src="dataObj.img" alt="" />
      </div>
      <div class="brBox">
        <div class="brbBpx">
          <div class="brtBox">Model：{{ dataObj.chipset }}</div>
          <div class="brbLeft">
            <div class="text">
              <h5>Frequency Range (MHz)</h5>
              <p>{{ dataObj.frequency }}</p>
            </div>

            <div class="text">
              <h5>3dB Horizontal Beam Width (° )</h5>
              <p>{{ dataObj.hor }}</p>
            </div>
            <div class="text">
              <h5>Gain (dBi)</h5>
              <p>{{ dataObj.gain }}</p>
            </div>
            <div class="text">
              <h5>Electrical Downtilt(° )</h5>
              <p>{{ dataObj.electrical }}</p>
            </div>
            <div class="text">
              <h5>Dimension(mm)</h5>
              <p>{{ dataObj.dimension }}</p>
            </div>
            <div class="text">
              <h5>Radome Material</h5>
              <p>{{ dataObj.radome }}</p>
            </div>
            <div class="text">
              <h5>Connector Type</h5>
              <p>{{ dataObj.connector }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productDetailObj } from '@/static/productsDetail.js'
export default {
  data () {
    return {
      dataObj: {}
    }
  },
  mounted () {
    this.dataObj = productDetailObj[this.$route.query.id]
    console.log(this.dataObj)
  }
}
</script>

<style lang="less" scoped>
.productDetailBox {
  .productDetail {
    width: 1150px;
    margin: 0 auto;
    .title {
      font-size: 28px;
      margin-bottom: 30px;
      color: #0057b8;
    }
    .bigBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .blBox {
        width: 520px;
        height: 500px;
        border: 2px solid #c5c5c5;
        border-radius: 20px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .img {
          width: 500px;
          height: 400px;
        }
      }
      .brBox {
        .brbBpx {
          width: 620px;
          height: 500px;
          background-color: #f2f2f2;
          padding: 20px;
          border-radius: 20px;
          // display: flex;
          // justify-content: space-between;
          // align-content: center;
          .brtBox {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
          }
          .brbLeft {
            //   width: 400px;
            .text {
              margin-bottom: 20px;
              color: #373737;
              word-wrap: break-word;
              word-break: break-all;
              h5 {
                font-weight: 600;
                font-size: 14px;
                color: #494949;
              }
            }
          }
        }
      }
    }
    .footerBox {
      width: 100%;
      height: 370px;
      margin-top: 50px;
      .imgBox {
        // width: 100%;
        height: 100%;
      }
    }
  }
  .productDetailTwo {
    width: 90%;
    margin: 0 auto;
    .title {
      font-size: 20px;
      margin: 20px 0;
      color: #0057b8;
    }

    .blBox {
      width: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .img {
        width: 60%;
      }
    }
    .brBox {
      .brbBpx {
        width: 100%;
        .brtBox {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
        }
        .brbLeft {
          //   width: 400px;
          .text {
            margin-bottom: 20px;
            color: #373737;
            word-wrap: break-word;
            word-break: break-all;
            h5 {
              font-weight: 600;
              font-size: 14px;
              color: #494949;
            }
          }
        }
      }
    }
  }
}

//当屏幕最小宽度为1300px
@media screen and (min-width: 1200px) {
  .productDetailBox {
    height: 740px;
    .productDetailTwo {
      display: none;
    }
  }
}
//当屏幕宽度 最小为1000px 最大为1300px时
@media screen and (min-width: 800px) and (max-width: 1200px) {
  .productDetailBox {
    .productDetail {
      display: none;
    }
    .productDetailTwo {
      width: 90%;
      margin: 0 auto;
    }
  }
}

//当屏幕最大宽度为800px
@media screen and (max-width: 800px) {
  .productDetailBox {
    .productDetail {
      display: none;
    }
    .productDetailTwo {
      width: 90%;
      margin: 0 auto;
      .title {
        font-size: 16px;
      }
    }
  }
}
</style>
